if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]') || this;
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement?.(this.openedBy);
      if (this.modalContent) this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    async show(opener) {
      // --- UI: loading state (safe checks) ---
      opener?.setAttribute?.('aria-disabled', true);
      opener?.classList?.add('loading');
      const spinner = opener?.querySelector?.('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      // Optional: your jQuery progress markers (won’t error if $ isn’t present)
      try {
        setTimeout(() => {
          if (window.jQuery) jQuery('.quick-add-modal[open]').find('.main-product_info').addClass('quick-add-modal-in-progress');
        }, 2000);
        setTimeout(() => {
          if (window.jQuery) jQuery('.main-product_info').removeClass('quick-add-modal-in-progress');
        }, 4000);
      } catch (_) {}

      try {
        const productUrl = opener?.getAttribute?.('data-product-url');
        if (!productUrl) throw new Error('Missing data-product-url on opener');

        // Try multiple endpoints for best compatibility
        const candidates = [
          `${productUrl}?view=quick-add`,          // preferred partial view if present
          `${productUrl}?view=quick_view`,         // alternate view
          `${productUrl}?section_id=main-product`, // section render API (Dawn-like)
          productUrl                                // full page fallback
        ];

        let responseText = '';
        for (const url of candidates) {
          try {
            const res = await fetch(url, { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (res.ok) {
              const txt = await res.text();
              // Heuristic: ensure we actually got HTML (not an empty response)
              if (txt && txt.length > 200) {
                responseText = txt;
                break;
              }
            }
          } catch (e) {
            // continue to next candidate
          }
        }

        if (!responseText) throw new Error('Unable to load quick view HTML');

        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

        // Robust ways to find the product chunk in various themes
        const selectors = [
          'section[id^="MainProduct-"]',
          '[data-section-type="main-product"]',
          '[data-section="main-product"]',
          '#MainContent .product',                  // generic OS 2.0 product wrapper
          '#MainContent form[action^="/cart/add"]', // last-resort: a form
          'form[action^="/cart/add"]'
        ];

        this.productElement = null;
        for (const sel of selectors) {
          const node = responseHTML.querySelector(sel);
          if (node) { this.productElement = node; break; }
        }

        // As a fallback, use the full body (not ideal, but better than empty)
        if (!this.productElement) this.productElement = responseHTML.body;

        // Defensive cleanup and id de-duplication
        this.preventDuplicatedIDs();
        this.removeDOMElements();

        // Inject inner HTML and re-run any scripts from the response
        this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

        // Shopify helpers if present
        try { if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init(); } catch (_) {}
        try { if (window.ProductModel) window.ProductModel.loadShopifyXR(); } catch (_) {}
        try { if (typeof DTWishlist === 'function') DTWishlist(); } catch (_) {}

        // Extra cleanups / UX tweaks
        this.removeGalleryListSemantic();
        this.preventVariantURLSwitching();

        // Finally show the dialog
        super.show(opener);
      } catch (err) {
        // Graceful fallback content
        if (this.modalContent) {
          const link = opener?.getAttribute?.('data-product-url') || '#';
          this.modalContent.innerHTML = `
            <div class="quick-view-fallback">
              <p>We couldn’t load the quick view for this product right now.</p>
              <p><a href="${link}">Open full product page</a></p>
            </div>
          `;
        }
        super.show(opener);
        console.error('[quick-add-modal] ', err);
      } finally {
        // --- UI: remove loading state ---
        opener?.removeAttribute?.('aria-disabled');
        opener?.classList?.remove('loading');
        const spinner2 = opener?.querySelector?.('.loading-overlay__spinner');
        if (spinner2) spinner2.classList.add('hidden');
      }
    }

    setInnerHTML(element, html) {
      if (!element) return;
      element.innerHTML = html;

      // Re-inject script tags so they execute
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent?.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');

      // Your jQuery color click handler, guarded
      try {
        if (window.jQuery) {
          jQuery('input:radio[name="Color"]').on('click', function () {
            jQuery('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
            jQuery(this).next('.swatch-element').addClass('clicked');
          });
        }
      } catch (_) {}
    }

    removeDOMElements() {
      if (!this.productElement) return;

      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const productEnquiry = this.productElement.querySelector('enquiryPopUp');
      if (productEnquiry) productEnquiry.remove();

      const modalDialogs = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialogs?.length) modalDialogs.forEach(m => m.remove());
    }

    preventDuplicatedIDs() {
      if (!this.productElement) return;
      const sectionId = this.productElement.dataset?.section;
      if (!sectionId) return; // nothing to replace

      // Ensure replaceAll exists and sectionId is non-empty
      if (typeof this.productElement.innerHTML === 'string' && sectionId) {
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      }

      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent?.querySelector?.('[id^="Slider-Gallery"]');
      if (galleryList) {
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }

      const FBT = this.modalContent?.querySelector?.('[id^="dT_bundleSelector"]');
      if (FBT) FBT.remove();

      const Tabs = this.modalContent?.querySelector?.('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
    }
  });
}
